import { MongoObservable } from "meteor-rxjs";
import { Activity } from "../models";

export const Activities = new MongoObservable.Collection<Activity>("activities", { connection: null });
Meteor.startup(() => {
    if (Meteor.isServer) {
        Activities.collection._ensureIndex({updateId: 1});
        Activities.collection._ensureIndex({logId: 1});
        Activities.collection._ensureIndex({projectId: 1});
        Activities.collection._ensureIndex({p6ActivityId: 1});
        Activities.collection._ensureIndex({criticality: 1});
        Activities.collection._ensureIndex({taskType: 1});
        Activities.collection._ensureIndex({touchedThisPeriod: 1});
        Activities.collection._ensureIndex({assignedUserId: 1});
        Activities.collection._ensureIndex({activityStatus: 1});
        Activities.collection._ensureIndex({isFlagged: 1});
        Activities.collection._ensureIndex({"tskActRows.actv_code_type_id": 1});
        Activities.collection._ensureIndex({"tskActRows.actv_code_id": 1});
        Activities.collection._ensureIndex({startDate: 1});
        Activities.collection._ensureIndex({finishDate: 1});
        Activities.collection._ensureIndex({activityName: 1});
        Activities.collection._ensureIndex({
            "activityName": "text",
            "p6ActivityId": "text"
        });
        Activities.collection._ensureIndex({totalFloat: 1});
    }
});



// WEBPACK FOOTER //
// ./src/api/server/collections/activities.ts